import { useDispatch } from "react-redux";
import {
  storePssSelectSidebarShow,
  storePssSelectSidebarUnfoldable,
  storePssSetLayout,
} from "../datasources/_pss.layout.store.slice";
import { usePssTypedSelector } from "../../../configs/_pss.store.slice";
import { UserRoleModel } from "../../../types/models/userRole.model";
import { storePssSelectCurrentRole } from "../../authentication/datasources/_pss.auth.store.slice";

export const usePssSidebarController = () => {
  const dispatch = useDispatch();
  const unfoldable = usePssTypedSelector<boolean>(
    storePssSelectSidebarUnfoldable,
  );
  const sidebarShow = usePssTypedSelector<boolean>(storePssSelectSidebarShow);
  const userRoles = usePssTypedSelector<UserRoleModel[]>(
    storePssSelectCurrentRole,
  );

  const setSidebarShow = (visible: boolean) => {
    dispatch(storePssSetLayout({ type: "set", sidebarShow: visible }));
  };
  const toggleSidebarFold = () => {
    dispatch(
      storePssSetLayout({ type: "set", sidebarUnfoldable: !unfoldable }),
    );
  };

  return {
    state: {
      unfoldable,
      sidebarShow,
      userRoles,
    },
    action: {
      setSidebarShow,
      toggleSidebarFold,
    },
  };
};
